import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import ROUTES from '~/shared/constants/routes.const'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { TREASURE_TRAIL } from '~/statistics/constants'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import TimeSpent from '../TimeSpent'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  timeSpent: number
}

export default function TreasureTrailSummary({ showContent, onClick, timeSpent }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(timeSpent)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: TREASURE_TRAIL })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={TREASURE_TRAIL}
        iconAltText={TREASURE_TRAIL}
        iconSrcKey="scoreboard/treasure-trail.png"
        onClickTitle={onClickTitle}
        productHref={ROUTES.TREASURETRAIL}
        productSubtitle="Addition"
        productTitle={t('game')}
        showContent={showContent}
      />
      <div className="font-medium flex flex-start">
        <TimeSpent days={days} hours={hours} minutes={minutes} />
      </div>
    </button>
  )
}
